var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RepositoryForm',{attrs:{"repository":_vm.repository},on:{"repositorychanged":_vm.onRepositoryChanged}}),_c('StarTrendingChart',{ref:"starTrendingChart",attrs:{"height":_vm.starTrendingChartHeight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }